import StoryblokComponent from "@/lib/storyblok/storyblokSetup/StoryblokComponent/StoryblokComponent";
import { TagStoryblok } from "@/types/blok-types";
import clsx from "clsx";
import styles from "./tag.module.css";
const Tag = ({ blok, preview }: { blok: TagStoryblok; preview: boolean }) => {
  return (
    <>
      <span className={styles["tag-link"]}>
        <StoryblokComponent blok={blok?.text?.[0]} preview={preview} />

        {blok?.media?.[0] && (
          <div className={styles["image-wrapper"]}>
            <div className={clsx(styles["tag-image"])}>
              <StoryblokComponent blok={blok?.media?.[0]} preview={preview} />
            </div>
          </div>
        )}
      </span>
    </>
  );
};

export default Tag;
